<template>
  <Badge :value="label" :theme="theme" />
</template>

<script>
import Badge from '@/components/Badge'

const Map = {
  draft: { label: 'contractStatusDraft', theme: 'default' },
  unsigned: { label: 'awaitingSignature', theme: 'primary' },
  signed: { label: 'contractStatusNotAccepted', theme: 'warning' },
  accepted: { label: 'signed', theme: 'success' },
  declined: { label: 'contractStatusDeclined', theme: 'error' },
}

export default {
  props: {
    value: String,
  },
  computed: {
    label() {
      return this.$tc(Map[this.value].label)
    },
    theme() {
      return Map[this.value].theme
    },
  },
  components: {
    Badge,
  },
}
</script>

<style lang="scss" scoped></style>
